import Vue from 'vue'

import rdParty from '@packages/3rd-party'
Vue.use(rdParty);

import txWoocommerce from '@packages/tx-woocommerce'
Vue.use(txWoocommerce);

import txUi from '@packages/tx-ui'
import txRendererUtils from '@packages/tx-renderer-utils'
import txProducts from '@packages/tx-products'
import txAdmin from '@packages/tx-admin'
import txTangram from '@packages/tx-tangram'

Vue.use(txUi);
Vue.use(txRendererUtils);
Vue.use(txTangram);
Vue.use(txProducts);
Vue.use(txAdmin);